module.exports = __webpack_public_path__ + "media/images/news/voip-banner-5ad224d0c9aa31cde2f8bd2fea86c804.png";